import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  FormGroup,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import ReactSelect from "react-select";
import Calendar from "assets/icon/calendar-icon.svg";
import ReactInputMask from "react-input-mask";
import { Field, Formik } from "formik";
import DatePicker from "react-datepicker";
import useContextService from 'hooks/useContextService';
import searchiocn from "assets/icon/search.svg";
import reseticon from "assets/icon/reset.svg";
import useAxios from "hooks/useAxios";
import { Option, LimitedChipsContainer } from "components/Options";
import moment from "moment";
import { cloneDeep, find } from 'lodash';
import FormikSelectField from "components/common/Fields/FormikSelectField";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import CoveredEntity from "components/CoveredEntity";

let hasDatePopupOpen = false;
let coveredEntitiesData = [];
let accumulationData = [];
let pharmacyData = [];
let cpData = [];
  let ceid=""

const SearchDashboard = (props) => {

  const {
    states: { dashboard },
    setStates,
    resetStates,
  } = useContextService();


  const {
    orgId,
    onSearch,
    search,
    searchTerms,
    addCrosswalk,
    startDateValue,
    endDateValue,
    setEndDate,
    setStartdate,
    onreset,
    auditCreated,
    tableData,
    totalrecords,
    selectedviewAudit,
    setSelectedViewAudit,
    setLoading,
    loading,
    selectsearch,
    setSelectSearch,
    selectedCEId,
  } = props;
  const [selectedCE, setSelectedCE] = useState(selectedCEId);
  const [selectedAccountType, setAccountTypeSelected] = useState(0);
  const [selectedCP, setSelectedCP] = useState(null);


  const [dateRangeValue, setDateRangeValue] = useState(4);

  const API = useAxios();
  const [selectedOption, setOptionSelected] = useState({ optionSelected: '-1' });
  const [selectedOpt, setOptSelected] = useState({
    optionSelected: "-1",
  });
  const [cpDatalist, setCpDatalist] = useState([]);
    const [error, setError] = useState(false)




  const dateRangeOption = [
    { id: 1, label: "Last 30 Days" },
    { id: 2, label: "Last 90 Days" },
    { id: 3, label: "Last 180 Days" },
    { id: 4, label: "Last 365 Days" },
  ];
  const handleDateRangeChange = ({ target: { value } }, setFieldValue) => {
    if (value) {
      const statusID = parseInt(value);
      const findObj = find(dateRangeOption, {
        id: statusID,
      });
      dashboard.selectedDateRange = findObj;
      dashboard.searchTerms.dateRangeID = findObj.id;
      // setFieldValue("dateRangeID", findObj.id);
      setDateRangeValue(value.id);
    } else {
      dashboard.selectedDateRange = {};
      dashboard.searchTerms.dateRangeID = "";
      setDateRangeValue(4);
    }
    updateStates(dashboard);
  };

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };
  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };
  const handlesearch = async (val) => {
    const values = cloneDeep(val);
 if(selectedCE ==undefined || "" || null){
      setError(true)
      return;
    }
    else if(selectedCE.length==0){
      setError(true)
      return;
    }
    else{
      setError(false)
    }
    values.CEIds = [];
    values.PHIds = dashboard.searchTerms.pharmacyIds != null ? [dashboard.searchTerms.pharmacyIds] : []
    values.CPIds = selectedCP != null ? [selectedCP.value] : [];
    values.dateRangeValue = dashboard.searchTerms.dateRangeID;

    dashboard.search.currentPage = 1;
    updateStates(dashboard);
    await onSearch(values);
    // setSubmitting(false);


  };
  
    useEffect(()=>{
  setCpDatalist([])
  setSelectedCP(null)
  setOptionSelected({ optionSelected: '-1' });
  pharmacyData=[]
  cpData=[]
        setError(false)
      setSelectedCE([])

},[orgId])

  const updateStates = (dashboard) => {
    setStates('dashboard', dashboard);
  };

  useEffect(()=>{
ceid=selectedCE
  },[selectedCE])

  const handleCoverdEntityChange = (value, entity, setFieldValue) => {
        setCpDatalist([])
    setSelectedCP(null)

    window.selectedCoveredEntittyId = value;

    if (entity) {
      const { coveredEntityID } = entity;
      setFieldValue('coveredEntityID', value.parseInt);
      setSelectedCE(value)
      pharmacyData = [];
        ceid=value
       if (ceid) {
        setError(false)
      }
      dashboard.coveredEntities = entity;
      if (dashboard.searchTerms.coveredEntityID != parseInt(value)) {
        dashboard.searchTerms.pharmacyIds = null;
      }
      dashboard.searchTerms.coveredEntityID = coveredEntityID;
      // fetchPharmacyName(coveredEntityID);
      fetchChainPharmacies(coveredEntityID);
      setOptionSelected({ optionSelected: '-1' });
    } else {
      setCpDatalist([])
      // setFieldValue('coveredEntityID', '');
      pharmacyData = [];
      dashboard.coveredEntities = {};
      dashboard.searchTerms.coveredEntityID = '';
      dashboard.searchTerms.pharmacyIds = null;
            ceid=window.selectedCoveredEntittyId
      setSelectedCE([])

    }
    updateStates(dashboard);
  };



  const handlePharmacyChange = (selected) => {
    if (selected) {
      setOptionSelected({
        optionSelected: selected
      });
      dashboard.searchTerms.pharmacyIds = selected.value;
    }
    else {
      dashboard.searchTerms.pharmacyIds = null;
      setOptionSelected({
        optionSelected: -1
      });
    }

    updateStates(dashboard);
  };

  const handleCPChange = (selected, setFieldValue) => {
    // setOptSelected({ optSelected: -1 });
     setOptionSelected({
        optionSelected: -1
      });
    if (selected) {
      pharmacyData = []
      // cperror = "";
      // setFieldValue("chainParmacyID", selected);
      setSelectedCP(selected);
      fetchPharmacyNamesBasedOnCP(selected);
      dashboard.searchTerms.chainPharmacyID = selected.value;

    } else {
      setOptionSelected({
        optionSelected: -1
      });
       fetchChainPharmacies(window.selectedCoveredEntittyId);

      // setFieldValue("chainParmacyID", "");
      setSelectedCP();
      pharmacyData = [];
      dashboard.searchTerms.chainPharmacyID = [];

    }
    updateStates(dashboard);
  };

  const fetchChainPharmacies = async (coveredEntityID) => {
    setCpDatalist([]);
    cpData = [];
    try {
      const { data } = await API.get(
        `RCMConfig/coveredentity/cpandph/${coveredEntityID}`,
        {
          hasDefaultURL: true,
        }
      );
      if (data) {
        for (var x in data.chainPharmacies) {
          if (!cpData.some(item => item.value === data.chainPharmacies[x].chainPharmacyID)) {
            cpData.push({ value: data.chainPharmacies[x].chainPharmacyID, label: data.chainPharmacies[x].chainPharmacyName });
          }
        }
        for (var x in data.pharmacies) {
          if (!pharmacyData.some(item => item.value === data.pharmacies[x].pharmacyID)) {
            pharmacyData.push({ "value": data.pharmacies[x].pharmacyID, "label": data.pharmacies[x].pharmacyName });
          }
        }
        setCpDatalist(cpData);
        // setOptionSelected(pharmacySelected);
      }
    } catch (error) {
      console.log(error.message);
    }
  };


  const fetchPharmacyNamesBasedOnCP = async (CPid) => {
    var payload = {};
    let CEID = dashboard.coveredEntities.coveredEntityID;
    try {
      payload.CoveredEntityIDs = [CEID];
      payload.ChainPharmacyIds = [CPid.value];

      const { data } = await API.post(
        `RCMConfig/coveredentity/pharmacies`, payload,
        {
          hasDefaultURL: true,
        }
      );

      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({ "value": data[x].pharmacyID, "label": data[x].pharmacyName });
          }
        }

      }
      // if (pharmacyData.length == 1) {
      //   setOptionSelected({
      //     optionSelected: pharmacyData[0]
      //   });
      //   dashboard.searchTerms.pharmacyIds = pharmacyData[0].value;
      // }

    }
    catch (error) {
      console.log(error.message);
    }
  };

  const handleStartDate = (startDate) => {
    if (startDate !== null) {
      const date = moment(startDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setStartdate(date.toDate());
      }
      // handlecount()
    } else {
      setStartdate(null);
    }
  };
  const handleEndDate = (endDate) => {
    if (endDate !== null) {
      const date = moment(endDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setEndDate(date.toDate());
      }
      // handlecount()
    } else {
      setEndDate(null);
    }
  };



  const handlereset = () => {
    setSelectSearch(false);
    setSelectedCP(null);
    setDateRangeValue(4);
    setCpDatalist([]);
    setSelectedCE([]);
        setError(false)
    pharmacyData = [];
    cpData = [];
    window.selectedCoveredEntittyId = "";
    dashboard.selectedDateRange = {};
    dashboard.searchTerms.dateRangeID = "";
    setDateRangeValue(4);
    dashboard.coveredEntities = {};
    dashboard.coveredEntity = {};
    dashboard.searchTerms.coveredEntityID = '';
    onreset();
    setOptionSelected({ optionSelected: -1 });
    dashboard.searchTerms.pharmacyIds = null;
    resetStates('dashboard');
  };



  return (
    <div>
      <div>
        <h5 className="f-16 text-primary font-weight-700">Search Dashboard</h5>

        <Formik
          initialValues={""}
          onSubmit={""}
          // validationSchema={validationSchema}
          // enableReinitialize={true}
          children={(props) => {
            const {
              isSubmitting,
              handleSubmit,
              resetForm,
              setFieldValue,
              errors,
              touched,
            } = props;
            return (
              <div hidden={""}>
                <div>
                  <Row sm={5} className="d-flex" style={{}}>
                    <Col md={3} lg={3} sm={6} xs={6}>
                      <FormGroup>
                        <Label for="coveredentity">Covered Entity</Label>
                        <CoveredEntity
                          value={selectedCE}
                          name="coveredEntityName"
                          orgId={orgId}
                          onChange={(value, coveredEnty) =>
                            handleCoverdEntityChange(value, coveredEnty, setFieldValue)

                          }
                        />
                         {error==true ? (
                    <div className="text-danger f-12 position-absolute">
                      {"Please select covered entity"}
                    </div>
                  ) : null}
                      </FormGroup>
                    </Col>

                    <Col md={3} lg={3} sm={6} xs={6}>
                      <FormGroup>
                        <Label for="ChainPharmacy">Chain Pharmacy</Label>
                        <ReactSelect
                          name="ChainPharmacy"
                          id="ChainPharmacy"
                          options={cpDatalist}
                          closeMenuOnSelect={false}
                          isClearable={true}
                          hideSelectedOptions={false}
                          isSearchable={true}
                          value={selectedCP}
                          onChange={(e) => handleCPChange(e, setFieldValue)}
                          className="claim_info required"
                          maxMenuHeight={220}
                          styles={{
                            menu: (provided) => ({ ...provided, zIndex: 99 }),
                          }}
                        />

                      </FormGroup>
                    </Col>
                    <Col md={3} lg={3} sm={6} xs={6}>
                      <FormGroup>
                        <Label for="pharmacy"> Pharmacy</Label>
                        <ReactSelect
                          name='pharmacyID'
                          id="pharmacyID"
                          options={pharmacyData}
                          closeMenuOnSelect={false}
                          isClearable={true}
                          hideSelectedOptions={false}
                          isSearchable={true}
                          onChange={handlePharmacyChange}
                          value={selectedOption.optionSelected}
                          className='claim_info'
                          maxMenuHeight={220}
                          styles={{
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 99,
                            }),
                          }}
                        />

                      </FormGroup>
                    </Col>
                    <Col md={3} sm={3} xs={3}>
                      <Label for="dateRange">Date Range</Label>
                      <Field
                        id="dateRange"
                        name="dateRange"
                        // className="required"
                        type="text"
                        component={FormikSelectField}
                        options={dateRangeOption}
                        value={dateRangeValue}
                        hideDefaultoption={true}
                        onChange={(val) => handleDateRangeChange(val, setFieldValue)}
                        keys={{
                          id: "id",
                          label: "label",
                        }}
                      />
                    </Col>
                    {dateRangeValue == 5 && (
                      <Col md={3} sm={6}>
                        <Row>
                          <Col>
                            <FormGroup>
                              <Label>Start Date</Label>
                              <InputGroup onMouseLeave={handleMouseLeave}>
                                <Field
                                  type="text"
                                  id="startDate"
                                  name="startDate"
                                  autoComplete="off"
                                  placeholder="Select a date"
                                  value={""}
                                  maxDate={new Date()}
                                  component={FormikDatePicker}
                                  onChange={handleStartDate}
                                />
                                <InputGroupText
                                  onClick={() => handleDateClick("startDate")}
                                >
                                  <img src={Calendar} alt="" />
                                </InputGroupText>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col xs="auto" className="pt-3 mt-3">
                            <Label className="mt-1">-</Label>
                          </Col>
                          <Col>
                            <FormGroup>
                              <Label>End Date</Label>
                              <InputGroup onMouseLeave={handleMouseLeave}>
                                <Field
                                  type="text"
                                  id="endDate"
                                  name="endDate"
                                  autoComplete="off"
                                  maxDate={new Date()}
                                  placeholder="Select a date"
                                  value={""}
                                  component={FormikDatePicker}
                                  onChange={handleEndDate}
                                />
                                <InputGroupText
                                  onClick={() => handleDateClick("endDate")}
                                >
                                  <img src={Calendar} alt="" />
                                </InputGroupText>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    )}
                  </Row>
                </div>
                <div hidden={""}>
                  <Row md="auto" style={{ justifyContent: "flex-end" }}>
                    <Col sm={2} className="d-flex justify-content-end">
                      <Button
                        color="primary"
                        className="search"
                        onClick={handlesearch}
                      //    hidden={!(hasPermission('AD'))}
                      // hidden={!isAuidt}
                      >
                        <span className="right_5">
                          <img src={searchiocn} alt="" />
                        </span>{" "}
                        Search
                      </Button>
                      <Button
                        color="primary"
                        className="reset ms-2"
                        onClick={handlereset}
                      //   hidden={!(hasPermission('AD'))}
                      // hidden={!isAuidt}
                      >
                        <span className="right_5">
                          <img src={reseticon} alt="" />
                        </span>{" "}
                        Reset
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            );
          }}
        ></Formik>
      </div>
    </div>
  );
};

export default SearchDashboard;
